<article class="viewerAsset viewerAssetVideo mx-auto">
  <div class="viewerAssetVideoWrapper mx-auto" id="viewerAssetVideoWrapper">
    <span #wistiaContainer>
      <zbp-branded-wistia *ngIf="!componentRef"
                          [isViewerFullScreen]="false"
                          [isViewer]="true"
                          [wistiaCode]="asset.fileName"
                          (videoReady)="setLoaded()"
                          (videoError)="setError()"
                          (videoEnded)="setComplete()"
      />
    </span>
  </div>
</article>
